<template>
    <v-app>
        <RouterView></RouterView>
    </v-app>
</template>
